import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { LOADCOMMANDS } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
import './Commands.scss';
const BaseCommandDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const CommandDataTable = DataTableHoc(BaseCommandDataTable);

/**
 * LoadCommands main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The LoadCommands component.
 */
const LoadCommands = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto'>
        <React.Suspense fallback={<Loader />}>
          <CommandDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={LOADCOMMANDS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={LOADCOMMANDS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${LOADCOMMANDS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${LOADCOMMANDS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Command'}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default LoadCommands;
